export const HEARTBEAT_INTERVAL_MS = 5000

export enum NotificationsBroadcastMessages {
  APP_UNREAD_COUNTS = 'APP_UNREAD_COUNTS',
  APP_FOCUS_CHANGE = 'APP_FOCUS_CHANGE',
  APP_FOCUS_HEARTBEAT = 'APP_FOCUS_HEARTBEAT',
  APP_FOCUS_SYNC_REQUEST = 'APP_FOCUS_SYNC_REQUEST'
}

interface AppUnreadCountsMessage {
  type: NotificationsBroadcastMessages.APP_UNREAD_COUNTS
  payload: Record<string, number>
}

interface AppFocusPayload {
  appIdDefocused: string | null
  appIdFocused: string | null
  tabId: string
  at: string
}

export interface AppFocusChangeMessage {
  type: NotificationsBroadcastMessages.APP_FOCUS_CHANGE
  payload: AppFocusPayload
}

interface AppFocusHeartbeatPayload {
  tabId: string
  appIdFocused: string | null
  at: string
}

export interface AppFocusHeartbeatMessage {
  type: NotificationsBroadcastMessages.APP_FOCUS_HEARTBEAT
  payload: AppFocusHeartbeatPayload
}

interface AppFocusSyncRequestPayload {
  tabId: string
}

interface AppFocusSyncRequestMessage {
  type: NotificationsBroadcastMessages.APP_FOCUS_SYNC_REQUEST
  payload: AppFocusSyncRequestPayload
}

export type NotificationsBroadcastMessage =
  | AppUnreadCountsMessage
  | AppFocusChangeMessage
  | AppFocusHeartbeatMessage
  | AppFocusSyncRequestMessage
